import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { ITimelineItem, IUseTimelineItemsParams } from "./types";

export const useTimelineItems = ({ dueDate, currency }: IUseTimelineItemsParams) => {
    const { translate } = useTranslate();

    const items: Array<ITimelineItem> = useMemo(() => {
        const formattedDueDate = dueDate.format("MMMM D");
        const currencySign = currency.sign;

        return [
            {
                title: translate("pro.packages.timeline.item.1.title"),
                description: translate("pro.packages.timeline.item.1.description"),
                iconUrl: `/images/trial-modal/credit_card.svg`,
            },
            {
                title: translate("pro.packages.timeline.item.2.title"),
                description: translate("pro.packages.timeline.item.2.description", {
                    currency: currencySign,
                    dueDate: formattedDueDate,
                }),
                iconUrl: `/images/trial-modal/lightning.svg`,
            },
            {
                title: translate("pro.packages.timeline.item.3.title", {
                    dueDate: formattedDueDate,
                }),
                description: translate("pro.packages.timeline.item.3.description"),
                iconUrl: `/images/trial-modal/rocket.svg`,
            },
        ];
    }, [dueDate, currency, translate]);

    return items;
};
